import {DataSourceFootnote} from "./DataSourceFootnote";

import type {XeroPnLCogsAccount} from "@hooks/use-vnext";

interface XeroPnlCogsBreakdownProps {
    cogs: XeroPnLCogsAccount[];
    generatedAt?: string;
    showFootnote?: boolean;
}

function fmtCurrency(v: number): string {
    const abs = Math.abs(v);
    if (abs >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `$${(v / 1_000).toFixed(0)}K`;
    return `$${v.toLocaleString(undefined, {maximumFractionDigits: 0})}`;
}

export function XeroPnlCogsBreakdown({cogs, generatedAt, showFootnote = true}: XeroPnlCogsBreakdownProps) {
    if (!cogs.length) return null;

    return (
        <div>
            <h3 className="text-sm font-bold uppercase tracking-[2px] text-[#209DB3] mb-3">
                Cost of Sales — Breakdown
            </h3>
            <div className="overflow-x-auto border rounded-lg">
                <table className="w-full text-xs">
                    <thead>
                        <tr className="bg-[#209DB3]/10 border-b">
                            <th className="text-left px-3 py-2 font-medium text-[#209DB3]">Account</th>
                            <th className="text-right px-3 py-2 font-medium text-[#209DB3]">Total</th>
                            <th className="text-right px-3 py-2 font-medium text-[#209DB3]">% of Cost of Sales</th>
                            <th className="px-3 py-2 font-medium text-[#209DB3] w-[200px]">Share</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cogs.map((item) => (
                            <tr key={item.account_id} className="border-b border-gray-100 hover:bg-gray-50/50">
                                <td className="px-3 py-1.5 truncate max-w-[200px]" title={item.account_name}>
                                    {item.account_name}
                                </td>
                                <td className="text-right px-3 py-1.5 tabular-nums font-medium">
                                    {fmtCurrency(item.total)}
                                </td>
                                <td className="text-right px-3 py-1.5 tabular-nums">
                                    {item.pct_of_cogs}%
                                </td>
                                <td className="px-3 py-1.5">
                                    <div className="w-full bg-gray-100 rounded-full h-2">
                                        <div
                                            className="bg-[#FF5100] h-2 rounded-full transition-all"
                                            style={{width: `${Math.min(item.pct_of_cogs, 100)}%`}}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {showFootnote && <DataSourceFootnote generatedAt={generatedAt} />}
        </div>
    );
}
